module.exports = __webpack_public_path__ + "static/media/icon.b110f0e4.png";